import type { ActivityRecord } from '@/api/activity'
import type { ActivityItem, ActivityTone } from './types'

function toneOf(event: ActivityRecord['event_type']): ActivityTone {
  if (event === 'version_rejected') return 'danger'
  if (event === 'scope_opened' || !event) return 'default'
  return 'success'
}

export function toActivityItem(record: ActivityRecord, index: number): ActivityItem {
  return {
    id: [
      record.app_id,
      record.event_type ?? '',
      record.created_at,
      record.version_id ?? '',
      index,
    ].join(':'),
    app_id: record.app_id,
    appName: record.app_name,
    appIcon: record.app_icon ?? '',
    title: record.title,
    description: record.detail,
    created_at: record.created_at,
    tone: toneOf(record.event_type),
    event_type: record.event_type,
    version_id: record.version_id,
  }
}
